<template>
    <div style="margin: 20px">
        <v-card>
            <v-toolbar dense color="primary" dark align="center">
                <v-row>
                    <v-col cols="5" align="left">
                        <v-toolbar-title
                            >Sinottico QuickConnext Box</v-toolbar-title
                        >
                    </v-col>
                    <v-col cols="2" />
                    <v-col cols="5" align="right">
                        <v-btn small light @click="getCustomerDevices">
                            <v-icon color="primary">mdi-autorenew</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container v-if="gateways != null">
                <v-row align="center">
                    <v-col cols="4">
                        <v-select
                            label="Gateway"
                            :items="gateways"
                            item-value="device_id"
                            item-text="device_name"
                            v-model="selected_gateway"
                            @change="getDeviceInfo"
                        />
                    </v-col>
                    <v-col cols="1">
                        <v-btn
                            small
                            light
                            @click="getDeviceInfo"
                            :disabled="!selected_gateway > 0"
                        >
                            <v-icon color="primary">mdi-autorenew</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn
                            small
                            light
                            @click="cache_dialog.display = true"
                            :disabled="!selected_gateway > 0"
                        >
                            <v-icon color="error">mdi-broom</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    light
                                    @click="getCache()"
                                    :disabled="!selected_gateway > 0"
                                >
                                    <v-icon color="purple"
                                        >mdi-file-table</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Scarica cache</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    light
                                    @click="getlogs()"
                                    :disabled="!selected_gateway > 0"
                                >
                                    <v-icon color="amber"
                                        >mdi-list-box</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Scarica log</span>
                        </v-tooltip>
                    </v-col>
                    <!--<v-col cols="1">
                        <v-btn small light @click="setFanMode(0)" :disabled="!selected_gateway>0">
                            <v-icon color="teal">mdi-fan-auto</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn small light @click="setFanMode(1)" :disabled="!selected_gateway>0">
                            <v-icon color="success">mdi-fan</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn small light @click="setFanMode(2)" :disabled="!selected_gateway>0">
                            <v-icon color="error">mdi-fan-off</v-icon>
                        </v-btn>
                    </v-col>-->
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-treeview
                            hoverable
                            :items="items"
                            v-if="items != null"
                            dense
                            :open-all="expanded"
                            item-key="__key"
                        >
                            <template v-slot:prepend="{ item }">
                                <div v-show="item.tipologia == 'system'">
                                    <v-chip
                                        label
                                        outlined
                                        color="grey darken-1"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-chip</v-icon
                                        >
                                        Sistema
                                    </v-chip>
                                </div>

                                <div v-show="item.tipologia == 'general'">
                                    <v-chip label outlined color="indigo">
                                        <v-icon small class="mr-2"
                                            >mdi-information-outline</v-icon
                                        >
                                        Informazioni generali
                                    </v-chip>
                                </div>
                                <div
                                    v-show="item.tipologia == 'general_detail'"
                                >
                                    <p class="my-2">
                                        <strong>Versione core:</strong>
                                        {{ item.core_version }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Versione runtime:</strong>
                                        {{ item.runtime_version }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Versione VNC server:</strong>
                                        {{ item.vnc_version }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Versione patch:</strong>
                                        {{ item.patch_version }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Sistema operativo:</strong>
                                        {{ item.os_description }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Architettura:</strong>
                                        {{ item.os_architecture }}
                                    </p>
                                    <p class="my-2">
                                        <strong
                                            >Avvio sistema operativo:</strong
                                        >
                                        {{ item.system_uptime }}
                                    </p>
                                    <p class="my-2">
                                        <strong
                                            >Avvio servizio
                                            QuickConnext:</strong
                                        >
                                        {{ item.uptime }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Orologio di sistema:</strong>
                                        {{ item.current_clock }}
                                    </p>
                                </div>

                                <div v-show="item.tipologia == 'temperature'">
                                    <v-chip
                                        label
                                        outlined
                                        color="amber darken-4"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-thermometer</v-icon
                                        >
                                        Controllo temperatura
                                    </v-chip>
                                </div>
                                <div
                                    v-show="
                                        item.tipologia == 'temperature_detail'
                                    "
                                >
                                    <p class="my-2">
                                        <strong>Driver temperatura CPU:</strong>
                                        {{
                                            item.cpu_temperature_driver_status
                                                ? "Rilevato"
                                                : "Non rilevato"
                                        }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Temperatura CPU:</strong>
                                        {{ item.cpu_temperature }} °C
                                    </p>
                                    <p class="my-2">
                                        <strong>Stato ventola:</strong>
                                        {{
                                            item.fan_status
                                                ? "Attiva"
                                                : "Non attiva"
                                        }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Modalità ventola:</strong>
                                        {{ fan_modes[item.fan_mode] }}
                                    </p>
                                </div>

                                <div v-show="item.tipologia == 'network'">
                                    <v-chip label outlined color="blue-grey">
                                        <v-icon small class="mr-2"
                                            >mdi-lan-connect</v-icon
                                        >
                                        Informazioni sulla rete
                                    </v-chip>
                                </div>
                                <div
                                    v-show="
                                        item.tipologia == 'network_interface'
                                    "
                                >
                                    <p class="my-2">
                                        <v-icon
                                            small
                                            v-if="item.type == 'Loopback'"
                                            color="blue-grey"
                                            >mdi-cable-data</v-icon
                                        >
                                        <v-icon
                                            small
                                            v-else-if="item.type == 'Ethernet'"
                                            color="blue-grey"
                                            >mdi-ethernet</v-icon
                                        >
                                        <v-icon v-else color="blue-grey"
                                            >mdi-help-circle-outline</v-icon
                                        >
                                        {{ item.interface_name }}
                                    </p>
                                </div>
                                <div
                                    v-show="item.tipologia == 'network_detail'"
                                >
                                    <p class="my-2">
                                        <strong>Nome interfaccia:</strong>
                                        {{ item.interface_name }}
                                    </p>
                                    <p class="my-2">
                                        <strong>ID interfaccia:</strong>
                                        {{ item.id }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Status:</strong>
                                        {{ item.status }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Indirizzo IP:</strong>
                                        {{ item.ip }}
                                    </p>
                                    <p class="my-2">
                                        <strong>tipologia interfaccia:</strong>
                                        {{ item.type }}
                                    </p>
                                </div>

                                <div v-show="item.tipologia == 'macchine'">
                                    <v-chip
                                        label
                                        outlined
                                        color="grey darken-2"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-robot-industrial</v-icon
                                        >
                                        Configurazione macchine
                                    </v-chip>
                                </div>

                                <h4 v-show="item.tipologia == 'macchina'">
                                    {{ item.machine_id }} -
                                    {{ item.machine_description }}
                                </h4>

                                <h4 v-show="item.tipologia == 'interface'">
                                    {{ item.interface_name }}
                                </h4>
                                <div
                                    v-show="
                                        item.tipologia == 'interfaccia_detail'
                                    "
                                >
                                    <p class="my-2">
                                        <strong>ID interfaccia:</strong>
                                        {{ item.interface_id }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Stato interfaccia:</strong>
                                        {{
                                            item.interface_task_status
                                                ? "Connessa"
                                                : "Non connessa"
                                        }}
                                    </p>
                                    <p
                                        class="my-2"
                                        v-if="!item.interface_task_status"
                                    >
                                        <strong
                                            >Dettaglio stato
                                            interfaccia:</strong
                                        >
                                        {{ item.interface_task_status_detail }}
                                    </p>
                                    <p class="my-2">
                                        <strong
                                            >Orario ultima connessione:</strong
                                        >
                                        {{ item.interface_task_uptime }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Frequenza di upload:</strong>
                                        {{ item.upload_frequency / 1000 + "s" }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Frequenza di polling:</strong>
                                        {{
                                            item.polling_frequency / 1000 + "s"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-show="item.tipologia == 'configurazione'"
                                >
                                    <v-chip
                                        label
                                        outlined
                                        color="teal darken-1"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-tune-vertical-variant</v-icon
                                        >
                                        Configurazione
                                    </v-chip>
                                </div>
                                <div
                                    v-show="
                                        item.tipologia ==
                                        'configurazione_detail'
                                    "
                                >
                                    <p
                                        class="my-2"
                                        v-for="(key, i) in item._keys"
                                        :key="i"
                                    >
                                        <strong>{{ key }}:</strong>
                                        {{ item[key] }}
                                    </p>
                                </div>

                                <div v-show="item.tipologia == 'registri'">
                                    <v-chip
                                        label
                                        outlined
                                        color="success darken-2"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-file-table-box-outline</v-icon
                                        >
                                        Registri
                                    </v-chip>
                                </div>
                                <div v-show="item.tipologia == 'registro'">
                                    <p class="my-2">
                                        <strong>Stato:</strong>
                                        <v-icon
                                            class="ml-2"
                                            :color="
                                                item.register_status === true
                                                    ? 'success'
                                                    : 'error'
                                            "
                                        >
                                            {{
                                                item.register_status === true
                                                    ? "mdi-check"
                                                    : "mdi-close"
                                            }}
                                        </v-icon>
                                    </p>
                                    <p
                                        class="my-2"
                                        v-show="!item.register_status"
                                    >
                                        <strong
                                            >Dettaglio stato registro:</strong
                                        >
                                        {{ item.status_detail }}
                                    </p>
                                </div>

                                <div v-show="item.tipologia == 'variabili'">
                                    <v-chip
                                        label
                                        outlined
                                        color="primary darken-2"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-cube-unfolded</v-icon
                                        >
                                        Variabili
                                    </v-chip>
                                </div>
                                <div v-show="item.tipologia == 'variabile'">
                                    <p class="my-2">
                                        <strong>Nome variabile:</strong>
                                        {{ item.variable_name }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Valore variabile:</strong>
                                        {{ item.value }}
                                    </p>
                                    <p class="my-2">
                                        <strong>Stato:</strong>
                                        <v-icon
                                            class="ml-2"
                                            :color="
                                                item.variable_status === true
                                                    ? 'success'
                                                    : 'error'
                                            "
                                        >
                                            {{
                                                item.variable_status === true
                                                    ? "mdi-check"
                                                    : "mdi-close"
                                            }}
                                        </v-icon>
                                    </p>
                                    <p
                                        class="my-2"
                                        v-if="!item.variable_status"
                                    >
                                        <strong
                                            >Dettaglio stato variabile:</strong
                                        >
                                        {{ item.status_detail }}
                                    </p>
                                </div>

                                <div v-show="item.tipologia == 'alarms'">
                                    <v-chip
                                        label
                                        outlined
                                        color="amber darken-2"
                                    >
                                        <v-icon small class="mr-2"
                                            >mdi-bell-alert-outline</v-icon
                                        >
                                        Allarmi
                                    </v-chip>
                                </div>
                                <span v-show="item.tipologia == 'allarme'">
                                    {{ item }}:</span
                                >
                            </template>

                            <!--template v-slot:append="{ item }">
                                <v-btn class="mr-5" small light v-if="item.tipologia == 'system' || item.tipologia == 'interface'">
                                    <v-icon color="amber darken-2"> mdi-autorenew </v-icon>
                                </v-btn>
                            </template-->
                        </v-treeview>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <v-dialog v-model="cache_dialog.display" width="600" persistent>
            <v-card>
                <v-container style="text-align: left">
                    <v-card-title
                        >Eliminare la cache del dispositivo?</v-card-title
                    >
                    <v-card-text
                        >I seguenti elementi saranno eliminati permanentemente
                        dal dispositivo:</v-card-text
                    >
                    <v-list dense>
                        <v-list-item
                            v-for="(item, i) in cache_dialog.items"
                            :key="i"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{
                                    item.text
                                }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-container>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        @click="cache_dialog.display = false"
                        >Annulla</v-btn
                    >
                    <v-spacer />
                    <v-btn text color="error" @click="clearCache"
                        >Elimina cache</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <VisualizzatoreCache
            :device_id="selected_gateway"
            v-if="selected_gateway != null"
            ref="cache_viewer"
        />
        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import NormalizzaTreeView from "./Normalizzatore.js";
import VisualizzatoreCache from "./VisualizzatoreCache.vue";
export default {
    name: "SinotticoQuickConnext",
    components: {
        VisualizzatoreCache,
        SnackbarQV,
    },
    data() {
        return {
            cache_dialog: {
                display: false,
                items: [
                    {
                        text: "Cache degli eventi e degli allarmi",
                        icon: "alarm-light",
                    },
                    {
                        text: "Cache dei dati acquisiti dai macchinari",
                        icon: "text-box",
                    },
                    {
                        text: "Configurazione dei macchinari e delle interfacce",
                        icon: "cog-transfer",
                    },
                ],
            },
            expanded: false,
            fan_modes: [
                "Auto",
                "Manuale - ON",
                "Manuale - OFF",
                "Non disponibile",
            ],
            gateways: null,
            items: null,
            NETWORK: null,
            selected_gateway: null,
        };
    },
    mounted() {
        this.NETWORK = this.$store.state.Network;
        this.getCustomerDevices();
        //this.items.push(this.buildTreeviewObj(this.json));
        //console.log(this.buildTreeviewObj(this.json));
    },
    methods: {
        getCache() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { check: false },
                body: {
                    action: "showcache",
                    id_dispositivo: this.selected_gateway,
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        const temp = document.createElement("a");
                        const file = new Blob([response], {
                            type: "text/plain",
                        });
                        temp.href = URL.createObjectURL(file);
                        temp.setAttribute("download", "cache.csv");
                        document.body.appendChild(temp);
                        temp.click();
                        document.body.removeChild(temp);
                    },
                    error: function (response) {
                        that.$refs.SnackbarQV.print(
                            "error",
                            "Errore: " + response
                        );
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        setUploadMode(mode) {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { check: false },
                body: {
                    action: "setuploadmode",
                    mode: mode,
                    id_dispositivo: this.selected_gateway,
                    token: localStorage.user_token,
                },
                method: "PUT",
                on: {
                    load: function () {
                        that.$refs.SnackbarQV.print(
                            "success",
                            "Modalita upload cambiato con successo"
                        );
                    },
                    error: function (response) {
                        that.$refs.SnackbarQV.print(
                            "error",
                            "Errore: " + response
                        );
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        getlogs() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { check: false },
                body: {
                    action: "getlogs",
                    id_dispositivo: this.selected_gateway,
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        const temp = document.createElement("a");
                        const file = new Blob([response], {
                            type: "text/plain",
                        });
                        temp.href = URL.createObjectURL(file);
                        temp.setAttribute("download", "log.csv");
                        document.body.appendChild(temp);
                        temp.click();
                        document.body.removeChild(temp);
                    },
                    error: function (response) {
                        that.$refs.SnackbarQV.print(
                            "error",
                            "Errore: " + response
                        );
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        getCustomerDevices() {
            this.gateways = null;
            this.selected_gateway = null;
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { check: false },
                body: {
                    action: "getcustomerdevices",
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        that.gateways = JSON.parse(response);
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        setFanMode(mode) {
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { parse: false },
                body: {
                    action: "fanmode",
                    token: localStorage.user_token,
                    id_dispositivo: this.selected_gateway,
                    timeout: 5,
                    mode: mode,
                },
                method: "PUT",
            };
            this.NETWORK.AjaxRequest(request);
        },
        clearCache() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { parse: false },
                body: {
                    action: "wipecache",
                    token: localStorage.user_token,
                    id_dispositivo: this.selected_gateway,
                },
                method: "PUT",
                on: {
                    load: function () {
                        that.cache_dialog.display = false;
                        that.getDeviceInfo();
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        async getDeviceInfo() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { check: false },
                body: {
                    action: "getdeviceinfo",
                    token: localStorage.user_token,
                    device_id: this.selected_gateway,
                    timeout: 5,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        that.items = [
                            NormalizzaTreeView(JSON.parse(response).detail),
                        ];
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
    },
};
</script>
